import React from "react";
import { Button, Modal, message } from "antd";
import { ExclamationCircleFilled, DownloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const DownloadButton = ({ apiUrl }: { apiUrl: string }) => {
    const { t } = useTranslation();

    const showDownloadConfirmation = () => {
        Modal.confirm({
            icon: <ExclamationCircleFilled />,
            title: t("quiz.download.confirm"),
            onOk() {
                // Show loading state
                const hideLoading = message.loading(t("quiz.download.loading"), 0);

                try {
                    window.location.href = `${apiUrl}/quiz/download`;
                    message.success(t("quiz.download.success"));
                } finally {
                    hideLoading(); // Hide the loading message
                }
            },
            onCancel() {
                message.info(t("quiz.download.cancel"));
            },
        });
    };

    return (
        <Button
            onClick={showDownloadConfirmation}
            icon={<DownloadOutlined />}
        >
            {t("quiz.download.button")}
        </Button>
    );
};

export default DownloadButton;